module.exports = __webpack_public_path__ + "img/cynergy-logo-white.5cb8b492.png";